import { FormControl, Grid, TextField } from '@mui/material';
import { Controller, FieldError } from 'react-hook-form';

import { gridSize } from '@/shared/constants';
import { useState } from 'react';
import { TiposTextFieldNumberEnum } from './CustomTextFieldNumberComponente';

type CustomTextFieldProps = {
  label: string;
  error: FieldError | undefined;
  helperText: React.ReactNode;
  disabled?: boolean;
  shrink?: boolean;
  required?: boolean;

  type?: React.HTMLInputTypeAttribute;

  size?: {
    xs: number;
    sm: number;
    md: number;
    lg: number;
  };
  control: any;
  name: string;
  defaultValue?: string | number;
  max?: number;
  typeInput?: TiposTextFieldNumberEnum;
  endAdornmentInput?: React.ReactNode;
  startAdornment?: React.ReactNode;

};

const CustomCellphoneTextField: React.FC<CustomTextFieldProps> = ({
  label,
  error,
  helperText,
  required = true,
  disabled = false,
  shrink = false,
  size = gridSize,
  type = 'tel',
  control,
  name,
  defaultValue,
  max = 10,
  endAdornmentInput,
  startAdornment
  // typeInput = TiposTextFieldNumberEnum.CELULAR,
}) => {
  const [errorAux, setErrorAux] = useState<boolean>(!!error);

  return (
    <Grid item {...size}>
      <FormControl fullWidth variant="outlined">
        <Controller
          control={control}
          name={name}
          defaultValue={defaultValue ?? ''}
          // disabled={disabled}
          render={({ field }) => {
            const onChange = (event: any) => {
              if (disabled) return;
              let inputValue = event.target.value;
              if (inputValue == '') {
                field.onChange('');
              }

              if (/^\d+$/.test(inputValue)) {
                switch (type) {
                  case 'tel':
                  case TiposTextFieldNumberEnum.CELULAR:
                    if (inputValue.length >= max) {
                      inputValue = inputValue.slice(0, max);
                      setErrorAux(false);
                    } else if (
                      inputValue.length >= 2 &&
                      !inputValue.startsWith('09')
                    ) {
                      inputValue = inputValue.slice(0, 2);
                      helperText =
                        'Los dos primeros caracteres deben empezar con "09"';
                      setErrorAux(true);
                    } else {
                      setErrorAux(true);
                      helperText = 'El número debe contener 10 caracteres';
                    }
                    break;
                  case TiposTextFieldNumberEnum.TARJETA:
                    if (inputValue.length >= max) {
                      inputValue = inputValue.slice(0, max);
                      setErrorAux(false);
                    }
                    break;

                  default:
                    break;
                }

                field.onChange(inputValue);
              }
            };

            return (
              <TextField
                fullWidth
                autoComplete='off'
                variant="outlined"
                label={label}
                disabled={disabled}
                InputLabelProps={{ ...(shrink && { shrink: true }) }}
                InputProps={{
                  ...(endAdornmentInput && {
                    endAdornment: endAdornmentInput,
                  }),
                  startAdornment: startAdornment ?? null,
                }}
                {...field}
                error={!!error || errorAux}
                helperText={helperText}
                type={type}
                required={required}
                onChange={onChange}
                sx={{
                  ...(disabled && { background: 'rgba(0, 0, 0, 0.04)' }),
                }}
              />
            );
          }}
        ></Controller>
      </FormControl>
    </Grid>
  );
};

export default CustomCellphoneTextField;
